module.exports = __webpack_public_path__ + "static/media/apluslogo.13b16ecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/apluslogo.png
// module id = 378
// module chunks = 0